import Table from './table';

function table(props) {
  return new Table(props);
}

export default table;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/table/index.js
// module id = 570
// module chunks = 9